import { EnumHelper } from "@singularsystems/neo-core";
var LookupHelper = /** @class */ (function () {
    function LookupHelper() {
    }
    /**
     * Finds the value and display member of a class by convention.
     * Also uses the displayMember attribute if defined on any of the properties.
     * @param item An object instance
     * @param booleanValuesAllowed True if boolean values are allowed in the value member.
     */
    LookupHelper.findMembers = function (item, valueMember, displayMember, booleanValuesAllowed) {
        if (booleanValuesAllowed === void 0) { booleanValuesAllowed = false; }
        if (!displayMember || !valueMember) {
            if (EnumHelper.isEnumItem(item)) {
                valueMember = "id";
                displayMember = "name";
            }
            if (!displayMember) {
                var neoTypeInfo = item.constructor.neo;
                if (neoTypeInfo && neoTypeInfo.displayMember) {
                    displayMember = neoTypeInfo.displayMember.propertyName;
                }
            }
            for (var propName in item) {
                if (valueMember && displayMember)
                    break;
                var value = item[propName];
                if (value !== undefined && value !== null) {
                    if ((typeof (value) === "number" || (booleanValuesAllowed && typeof (value) === "boolean")) && !valueMember) {
                        valueMember = propName;
                    }
                    if (typeof (value) === "string" && !displayMember && !propName.toLowerCase().endsWith("id") && propName !== "entityIdentifier") {
                        displayMember = propName;
                    }
                }
            }
            if (!valueMember || !displayMember) {
                console.error("Could not find value and display member. Try specifying them explicitly.", item);
            }
        }
        return { valueMember: valueMember, displayMember: displayMember };
    };
    return LookupHelper;
}());
export default LookupHelper;
